/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfWorkspaceInviteCreatedDto } from "../models/AjaxResponseOfWorkspaceInviteCreatedDto";
import type { AjaxResponseOfWorkspaceInviteOptionsDto } from "../models/AjaxResponseOfWorkspaceInviteOptionsDto";
import type { AjaxResponseOfWorkspaceMembersDto } from "../models/AjaxResponseOfWorkspaceMembersDto";
import type { CreateWorkspaceInviteInput } from "../models/CreateWorkspaceInviteInput";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class WorkspaceMembersAppServiceAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfWorkspaceMembersDto Success
   * @throws ApiError
   */
  public getWorkspaceMembers(): CancelablePromise<AjaxResponseOfWorkspaceMembersDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/workspace-members",
    });
  }
  /**
   * @returns AjaxResponseOfWorkspaceInviteOptionsDto Success
   * @throws ApiError
   */
  public getWorkspaceInviteOptions(): CancelablePromise<AjaxResponseOfWorkspaceInviteOptionsDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/workspace-members/invite-options",
    });
  }
  /**
   * @returns AjaxResponseOfWorkspaceInviteCreatedDto Success
   * @throws ApiError
   */
  public createWorkspaceInvite({
    requestBody,
  }: {
    requestBody?: CreateWorkspaceInviteInput;
  }): CancelablePromise<AjaxResponseOfWorkspaceInviteCreatedDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/workspace-members/invites",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public removeWorkspaceMember({
    userId,
  }: {
    userId: number;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/workspace-members/{userId}",
      path: {
        userId: userId,
      },
    });
  }
}
